import { Role } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';
import { useUserCompanyList } from 'common/hooks/useUserCompanyList';

export const useHasAlreadyEiAccount = (): boolean => {
  const { companies } = useUserCompanyList();
  const { companyProfileId } = useCompanyContext();

  if (companyProfileId === undefined) {
    return false;
  }

  const otherCompanies = companies.filter(
    (company) => company.companyProfileId !== companyProfileId,
  );

  return (
    otherCompanies?.some((companyProfile) => {
      return (
        companyProfile.legalForm.startsWith('EI') &&
        companyProfile.roles.includes(Role.AccountHolder)
      );
    }) ?? false
  );
};
